import React, { Component } from 'react';

import TestVehicleMaximumPower from './TestVehicleMaximumPower';
import HelperCollections from '../../helpers/HelperCollections';
import IconRender from '../std/IconRender';
import ContMessageI18N from '../../containers/ContMessageI18N';

class TestVehicleMaximumPowers extends Component {

	render() {
		return (
			<div className="row border">
				<p><ContMessageI18N i18n='vehicle.features.maximumPowers' /></p>
				{this.props.data && this.props.data.map((occurence, index) => (
					<div key={index} className="row">
						<TestVehicleMaximumPower data={occurence} settings={this.props.settings}
							onChange={(data) => { HelperCollections.handleChange(data, index, this.props) }} />
						<div className="col-auto">
							<button className="btn btn-light" onClick={() => HelperCollections.handleDelete(occurence.value, 'value', this.props)} >
								<IconRender name="trash" />
							</button>
						</div>
						<div className="col-auto">
							<button className="btn btn-light" onClick={() => HelperCollections.handleCopy(occurence.value, 'value', this.props)} >
								<IconRender name="stickies" />
							</button>
						</div>
					</div>
				))}
				<div className="col-auto">
					<button className="btn btn-light" onClick={() => HelperCollections.handleAdd('value', this.props, 0.0)} >
						<IconRender name="plus" />
					</button>
				</div>
			</div>
		)
	}
}

export default (TestVehicleMaximumPowers)
